module.exports = __webpack_public_path__ + "static/bai_fct2-0b6314e65975f99ca6da791fe7a9309e.jpg";